import { Link } from "react-router-dom";

export default function Activity(activity) {
	return (
		<div className="activity">
			<div
				data-points={activity.points}
				className={`quiz-card ${activity.completed ? "completed" : ""} ${
					!activity.packet_activated && !activity.completed ? "disabled" : ""
				} ${
					activity.quiz_incorrect && activity.name === "Quiz" ? "incorrect" : ""
					// } ${
					// 	activity.link === "/bio" && !activity.show_bio
					// 		? "bio-hidden"
					// 		: "bio-shown"
				}`}
			>
				<Link
					className={`activity-link ${activity.completed ? "completed" : ""}`}
					to={`/${activity.packet_id}${activity.link}/${activity.id}`}
					state={{
						data: activity.data,
						packet_id: activity.packet_id,
						points: activity.points,
					}}
				>
					<div className="link-to" id="download-link">
						<div className={`left ${activity.completed ? "completed" : ""}`}>
							<img src={`/img/${activity.icon}`} />
							<div className="left-disabled">
								<svg
									width="63"
									height="63"
									viewBox="0 0 63 63"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g filter="url(#filter0_bii_237_1498)">
										<rect
											width="63"
											height="63"
											rx="15"
											fill="url(#paint0_linear_237_1498)"
											fill-opacity="0.1"
										/>
									</g>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M30.8123 19.0165C29.7849 19.1457 28.8011 19.5088 27.9439 20.0752C27.4674 20.3901 26.5957 21.2512 26.277 21.722C25.8225 22.3931 25.513 23.0982 25.3119 23.9204C25.2201 24.2954 25.2081 24.5312 25.1881 26.351L25.166 28.3662H24.6366C24.3208 28.3662 23.9899 28.3964 23.8165 28.441C22.9635 28.6605 22.3065 29.3117 22.0832 30.1589C21.9723 30.5793 21.9723 41.7867 22.0832 42.2072C22.3065 43.0544 22.9635 43.7055 23.8165 43.925C24.0713 43.9906 25.0218 43.9998 31.5047 43.9998C39.6457 43.9998 39.1663 44.0173 39.77 43.6994C40.338 43.4003 40.8272 42.7369 40.9495 42.0998C40.982 41.9304 40.9999 39.8099 40.9999 36.1378C40.9999 29.9358 41.0107 30.1876 40.7226 29.6261C40.546 29.2816 40.1164 28.8491 39.77 28.6667C39.3508 28.446 38.9801 28.3662 38.3727 28.3662H37.8433L37.8212 26.351C37.8012 24.5312 37.7892 24.2954 37.6975 23.9204C37.3908 22.6669 36.8576 21.72 35.962 20.8379C35.0435 19.9335 34.0835 19.4076 32.8399 19.1275C32.4271 19.0345 31.2023 18.9675 30.8123 19.0165ZM32.3466 21.1561C32.8121 21.2536 33.4098 21.4938 33.7749 21.73C34.7361 22.3519 35.4522 23.4006 35.6547 24.4825C35.687 24.655 35.7083 25.4844 35.7083 26.5676V28.3662H31.5047H27.301L27.3019 26.5464C27.3028 24.5591 27.3195 24.3959 27.5921 23.6994C28.0879 22.4325 29.2543 21.4601 30.6392 21.1591C31.0331 21.0735 31.9444 21.0719 32.3466 21.1561ZM32.2269 32.6721C32.96 32.9416 33.4587 33.5479 33.5851 34.3236C33.7005 35.0317 33.3811 35.8066 32.7903 36.2517L32.5476 36.4345L32.533 37.7948L32.5185 39.155L32.3679 39.3667C31.889 40.0403 30.8581 39.9465 30.5427 39.2007C30.4801 39.0529 30.4661 38.7835 30.4661 37.7288V36.4378L30.2151 36.2494C29.6322 35.8116 29.3092 35.0291 29.4232 34.3302C29.6028 33.2279 30.5812 32.4567 31.6778 32.5532C31.841 32.5676 32.0881 32.6211 32.2269 32.6721Z"
										fill="white"
										fill-opacity="0.1"
									/>
									<defs>
										<filter
											id="filter0_bii_237_1498"
											x="-5.5"
											y="-5.5"
											width="74"
											height="74"
											filterUnits="userSpaceOnUse"
											color-interpolation-filters="sRGB"
										>
											<feFlood flood-opacity="0" result="BackgroundImageFix" />
											<feGaussianBlur
												in="BackgroundImage"
												stdDeviation="2.75"
											/>
											<feComposite
												in2="SourceAlpha"
												operator="in"
												result="effect1_backgroundBlur_237_1498"
											/>
											<feBlend
												mode="normal"
												in="SourceGraphic"
												in2="effect1_backgroundBlur_237_1498"
												result="shape"
											/>
											<feColorMatrix
												in="SourceAlpha"
												type="matrix"
												values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
												result="hardAlpha"
											/>
											<feOffset dy="1.5" />
											<feGaussianBlur stdDeviation="1.25" />
											<feComposite
												in2="hardAlpha"
												operator="arithmetic"
												k2="-1"
												k3="1"
											/>
											<feColorMatrix
												type="matrix"
												values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
											/>
											<feBlend
												mode="normal"
												in2="shape"
												result="effect2_innerShadow_237_1498"
											/>
											<feColorMatrix
												in="SourceAlpha"
												type="matrix"
												values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
												result="hardAlpha"
											/>
											<feOffset dy="-2.75" />
											<feGaussianBlur stdDeviation="1.25" />
											<feComposite
												in2="hardAlpha"
												operator="arithmetic"
												k2="-1"
												k3="1"
											/>
											<feColorMatrix
												type="matrix"
												values="0 0 0 0 0.541176 0 0 0 0 0.219608 0 0 0 0 0.956863 0 0 0 0.15 0"
											/>
											<feBlend
												mode="normal"
												in2="effect2_innerShadow_237_1498"
												result="effect3_innerShadow_237_1498"
											/>
										</filter>
										<linearGradient
											id="paint0_linear_237_1498"
											x1="0"
											y1="31.5"
											x2="59.4134"
											y2="58.2042"
											gradientUnits="userSpaceOnUse"
										>
											<stop stop-color="#7549AE" />
											<stop offset="1" stop-color="#5D25A6" />
										</linearGradient>
									</defs>
								</svg>
							</div>
						</div>
						<div className={`middle ${activity.completed ? "completed" : ""}`}>
							<p className="quiz-name">{activity.name}</p>
							<div className="points">
								<img src="/img/small_star.png" />+{activity.points} points
							</div>
						</div>
						<div className={`right ${activity.completed ? "completed" : ""}`}>
							<div className="check-mark">
								<svg
									width="63"
									height="63"
									viewBox="0 0 63 63"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<rect
										width="63"
										height="63"
										rx="15"
										fill="white"
										fill-opacity="0.1"
									/>
									<path
										d="M26 33.4118L30.5405 38L40 25"
										stroke="#32FF47"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
								</svg>
							</div>
							<svg
								width="8"
								height="14"
								viewBox="0 0 8 14"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M1 13L7 7L1 1"
									stroke="#41295a"
									stroke-width="2"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
							</svg>
							<div className="right-disabled">
								<svg
									width="63"
									height="63"
									viewBox="0 0 63 63"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<rect
										width="63"
										height="63"
										rx="15"
										fill="white"
										fill-opacity="0.1"
									/>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M20.5332 21.0582C20.4039 21.1152 20.1999 21.3106 20.0706 21.5013C20.0063 21.5961 20.0002 21.9909 20.0002 26.0905C20.0002 31.0325 19.9825 30.7107 20.2666 30.9227C20.5958 31.1682 20.4929 31.1631 25.1875 31.1678C29.8592 31.1724 29.6562 31.182 29.8787 30.944C29.9304 30.8887 30.0167 30.7493 30.0706 30.6342L30.1686 30.4247L30.1808 26.268C30.1892 23.3986 30.1785 22.0259 30.1463 21.8356C30.0861 21.4801 29.9022 21.159 29.7065 21.0675C29.5724 21.0049 29.1506 20.9987 25.11 21.0002C21.4812 21.0015 20.6375 21.0122 20.5332 21.0582ZM32.3643 21.0456C32.1167 21.1425 31.9296 21.3953 31.8516 21.7381C31.787 22.0221 31.7938 30.0722 31.859 30.3748C31.9435 30.7677 32.1188 31.0158 32.3856 31.1199C32.5671 31.1907 41.19 31.1937 41.4074 31.123C41.4899 31.0962 41.6272 31.0037 41.7125 30.9174C42.0189 30.6078 41.9998 30.9296 41.9998 26.079C41.9998 22.2238 41.992 21.6913 41.9336 21.5535C41.8501 21.3567 41.6827 21.1817 41.4792 21.0787C41.3264 21.0013 41.1694 20.9986 36.896 21.0012C34.0703 21.0029 32.4324 21.0189 32.3643 21.0456ZM28.2298 26.079V29.2491L25.053 29.2598L21.8761 29.2706V26.1073C21.8761 24.3675 21.8891 22.9312 21.9048 22.9157C21.9206 22.9002 23.3502 22.8923 25.0817 22.8982L28.2298 22.909V26.079ZM40.0812 26.079V29.2701H36.9049H33.7286V26.079V22.888H36.9049H40.0812V26.079ZM24.8145 24.8189C24.4234 24.8859 24.116 25.1161 23.9167 25.4912C23.8317 25.6511 23.8163 25.7415 23.8164 26.079C23.8164 26.4297 23.8301 26.5036 23.9298 26.6898C24.0645 26.9416 24.2639 27.1445 24.4982 27.2682C24.7575 27.4051 25.3582 27.3989 25.6415 27.2563C25.8938 27.1294 26.16 26.8516 26.2799 26.5903C26.4194 26.2862 26.4084 25.8348 26.2539 25.524C25.9953 25.0034 25.4104 24.7169 24.8145 24.8189ZM36.6425 24.8189C36.3694 24.8755 36.1433 25.0071 35.9531 25.2199C35.5267 25.697 35.5267 26.5031 35.9531 26.9802C36.2012 27.2577 36.4061 27.3492 36.8312 27.3722C37.1622 27.3901 37.2011 27.3829 37.4643 27.2553C37.7741 27.1051 37.9585 26.8959 38.0862 26.5494C38.2377 26.1389 38.1541 25.5679 37.8932 25.2311C37.6377 24.9012 37.0999 24.7239 36.6425 24.8189ZM20.6573 32.863C20.4053 32.926 20.2703 33.024 20.1254 33.2488L20.0002 33.4433V37.883C20.0002 40.9116 20.0146 42.3603 20.0455 42.4409C20.106 42.5991 20.3263 42.821 20.5208 42.9197C20.6735 42.9973 20.8298 43 25.0843 43H29.4897L29.6796 42.9055C29.8884 42.8017 30.0338 42.6175 30.1154 42.3534C30.1564 42.2207 30.1686 41.2051 30.1686 37.9195C30.1686 33.8725 30.1646 33.6465 30.0893 33.4335C29.9901 33.1531 29.8065 32.9435 29.6016 32.8767C29.3903 32.8078 20.9299 32.7949 20.6573 32.863ZM32.4896 32.8963C32.1701 32.9812 32.0115 33.0944 31.8983 33.3186L31.7947 33.5238L31.8017 37.8123C31.8094 42.4658 31.8016 42.3101 32.0444 42.6715C32.2261 42.9418 32.407 42.998 33.0998 42.9991L33.686 43L33.6863 40.4283C33.6865 39.0138 33.6989 37.7286 33.7138 37.5724L33.7411 37.2881L34.7048 37.2994L35.6685 37.3107L35.6802 38.014L35.6919 38.7173H38.8032C40.5144 38.7173 41.9286 38.7126 41.9458 38.7068C41.9631 38.701 41.9831 37.5211 41.9904 36.0846C42.0034 33.5152 42.0022 33.4702 41.9156 33.303C41.812 33.1029 41.5853 32.9441 41.3176 32.8841C41.2121 32.8604 40.9031 32.8406 40.6308 32.84L40.136 32.839L40.1086 33.0971C40.0935 33.239 40.0812 34.1082 40.0812 35.0285V36.7019H39.1006H38.12V34.7704V32.839L35.402 32.8418C33.3932 32.8439 32.6333 32.8582 32.4896 32.8963ZM28.2298 37.9195V41.0896L25.053 41.1003L21.8761 41.1111V37.9478C21.8761 36.2079 21.8891 34.7717 21.9048 34.7562C21.9206 34.7406 23.3502 34.7328 25.0817 34.7387L28.2298 34.7495V37.9195ZM24.749 36.6553C24.1632 36.8039 23.8058 37.2327 23.7617 37.8397C23.7327 38.2386 23.8328 38.5083 24.1117 38.7829C24.417 39.0837 24.7207 39.1935 25.1803 39.1695C25.9133 39.1312 26.3743 38.6479 26.373 37.9195C26.372 37.4017 26.1105 36.9852 25.6457 36.7613C25.3986 36.6422 24.9905 36.594 24.749 36.6553ZM35.9137 40.7238L35.6898 40.7371V41.8685V43H36.7564H37.8229L37.8116 41.8576L37.8002 40.7153L36.9689 40.7129C36.5116 40.7116 36.0368 40.7165 35.9137 40.7238ZM39.9052 40.7218C39.802 40.7442 39.7837 40.9394 39.7832 42.0238L39.7828 43H40.5631H41.3435L41.5372 42.879C41.7328 42.7569 41.8548 42.6148 41.9486 42.3997C41.9824 42.3222 41.9998 42.0146 41.9998 41.4952V40.7082L40.9872 40.7075C40.4303 40.7071 39.9434 40.7135 39.9052 40.7218Z"
										fill="white"
									/>
								</svg>
							</div>
						</div>
					</div>
				</Link>
			</div>
		</div>
	);
}
